import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import parse from 'html-react-parser';
import PanelHeader from './PanelHeader';

export default function BasicMap(props) {
	const { mapurl, mapTitle, addtext=null, foottext=null } = props;
	const maxWidth = window.innerWidth - 260 - 48;	//drawerWidth=260  Main padding=48

	return (
		<>
			<PanelHeader
				title={mapTitle}
				addtext={addtext}
			/>
			<Box
				component="img"
				sx={{
					maxHeight: "700px",
					maxWidth: {maxWidth},
					position: "relative",
					left: "50%",
					transform: "translate(-50%, 0)",
				}}
				alt={mapTitle + " map"}
				src={mapurl}
			/>
			{foottext &&
				<Typography
					variant="body1"
					sx={{ p:1, mx:2, border:"1pt solid gray", backgroundColor:"#f2f2f2" }}
				>
					{parse(foottext)}
				</Typography>
			}
	   </>
	);
}